<div class="content-dialog">
    <div class="dialog-header">
        <h2 class="dialog-title">Creación de persona</h2>
        <button type="button" class="dialog-header__close" (click)="close()" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-scroll">

        <div class="warning-banner" *ngIf="warningMessages.length" [matTooltip]="warningMessages.join('\n')">
            <mat-icon class="warning-banner__icon">info</mat-icon>
            <span>Verifique los datos resaltados, no se leyeron con total certeza del documento.</span>
        </div>

        <div class="locked-banner" *ngIf="formLocked">
            <mat-icon class="locked-banner__icon">lock</mat-icon>
            <span>Los datos se extrajeron con alta confianza, por lo que los campos completados quedaron bloqueados. Los campos vacíos siguen editables para que los complete.</span>
        </div>

        <form [formGroup]="formPersonal" (ngSubmit)="onSubmit()">

            <div class="photo-section">
                <div class="photo-wrap" (click)="updatePhotoPersonal()">
                    <div class="photo-circle" [ngClass]="{'photo-circle--empty': formDataPhoto === undefined, 'photo-circle--required': photoRequired && formDataPhoto === undefined}">
                        <img *ngIf="imgCropperResult" [src]="imgCropperResult" alt="Foto">
                        <mat-icon *ngIf="!imgCropperResult">person</mat-icon>
                    </div>
                    <div class="photo-badge">
                        <mat-icon>photo_camera</mat-icon>
                    </div>
                </div>
            </div>

            <div class="form-grid">
                <div class="field-box grid-span-2" [ngClass]="fieldClasses('Nationality')">
                    <span class="field-box__label">NACIONALIDAD</span>
                    <div class="field-box__control">
                        <app-select-search
                                [_dataSource]="nationality" [textInput]="''" [dataShow]="'Description'" [dataValue]="'Value'" [siteCtrl]="formPersonal.get('Nationality')"
                                [inputType]="'text'">
                        </app-select-search>
                    </div>
                </div>
                <div class="field-box" [ngClass]="fieldClasses('DocumentType')">
                    <span class="field-box__label">TIPO DE DOCUMENTO</span>
                    <div class="field-box__control">
                        <mat-icon class="field-box__icon">perm_identity</mat-icon>
                        <mat-form-field>
                            <mat-select formControlName="DocumentType" (selectionChange)="changeType($event.value)">
                                <mat-option *ngFor="let data of companyDocumentType" [value]="data.Value">
                                    {{(data.Description === 'C.C.' ? 'Cedula': data.Description)}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="field-box" [ngClass]="fieldClasses('DocumentNumber')">
                    <span class="field-box__label">NÚMERO DE DOCUMENTO</span>
                    <div class="field-box__control">
                        <mat-icon class="field-box__icon">label</mat-icon>
                        <mat-form-field>
                            <input matInput type="text" formControlName="DocumentNumber" (input)="formatDocumentNumber($event, formPersonal, 'DocumentNumber')" maxlength="{{maxCaracter + 6}}">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="form-grid form-grid--spaced">
                <div class="field-box toUpperCaseInput" [ngClass]="fieldClasses('Name')">
                    <span class="field-box__label">NOMBRES</span>
                    <div class="field-box__control">
                        <mat-icon class="field-box__icon">person_outline</mat-icon>
                        <mat-form-field>
                            <input matInput type="text" formControlName="Name" (input)="convertirAMayusculas($event, formPersonal, 'Name')">
                        </mat-form-field>
                    </div>
                </div>
                <div class="field-box toUpperCaseInput" [ngClass]="fieldClasses('LastName')">
                    <span class="field-box__label">APELLIDOS</span>
                    <div class="field-box__control">
                        <mat-icon class="field-box__icon">person_outline</mat-icon>
                        <mat-form-field>
                            <input matInput type="text" formControlName="LastName" (input)="convertirAMayusculas($event, formPersonal, 'LastName')">
                        </mat-form-field>
                    </div>
                </div>

                <div class="triple-row grid-span-2">
                    <div class="field-box field-box--wide" [ngClass]="fieldClasses('BirthDate')">
                        <span class="field-box__label">FECHA DE NACIMIENTO</span>
                        <div class="field-box__control">
                            <mat-icon class="field-box__icon">event</mat-icon>
                            <mat-form-field>
                                <input matInput [matDatepicker]="picker" formControlName="BirthDate" (click)="picker.open()">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="field-box" [ngClass]="fieldClasses('Sex')">
                        <span class="field-box__label">SEXO</span>
                        <div class="field-box__control">
                            <mat-icon class="field-box__icon">wc</mat-icon>
                            <app-select-search
                                    [_dataSource]="sex" [textInput]="''" [dataShow]="'Value'" [dataValue]="'Value'" [siteCtrl]="formPersonal.get('Sex')"
                                    [inputType]="'text'">
                            </app-select-search>
                        </div>
                    </div>
                    <div class="field-box" [ngClass]="fieldClasses('RH')">
                        <span class="field-box__label">RH</span>
                        <div class="field-box__control">
                            <mat-icon class="field-box__icon">opacity</mat-icon>
                            <app-select-search
                                    [_dataSource]="rh" [textInput]="''" [dataShow]="'Description'" [dataValue]="'Value'" [siteCtrl]="formPersonal.get('RH')"
                                    [inputType]="'text'">
                            </app-select-search>
                        </div>
                    </div>
                </div>

                <div class="field-box grid-span-2" [ngClass]="fieldClasses('contryNalcionality')">
                    <span class="field-box__label">PAÍS DE NACIMIENTO</span>
                    <div class="field-box__control">
                        <mat-icon class="field-box__icon">public</mat-icon>
                        <app-select-search
                                [_dataSource]="countrys" [textInput]="''" [dataShow]="'Description'" [dataValue]="'Value'" [siteCtrl]="formPersonal.get('contryNalcionality')"
                                [inputType]="'text'" (onSelectionChange)="getCitiesNacimiento($event)">
                        </app-select-search>
                    </div>
                </div>
                <div class="field-box grid-span-2" [ngClass]="fieldClasses('CityBirthCode')">
                    <span class="field-box__label">CIUDAD DE NACIMIENTO</span>
                    <div class="field-box__control">
                        <mat-icon class="field-box__icon">place</mat-icon>
                        <app-select-search
                                [_dataSource]="citiesNacimiento" [textInput]="''" [dataShow]="'Name'" [dataValue]="'Code'" [siteCtrl]="formPersonal.get('CityBirthCode')"
                                [inputType]="'text'">
                        </app-select-search>
                    </div>
                </div>
            </div>

            <div class="missing-banner" *ngIf="missingFieldLabels.length">
                <mat-icon class="missing-banner__icon">error_outline</mat-icon>
                <span>Para habilitar Guardar, completa: {{ missingFieldLabels.join(', ') }}.</span>
            </div>

            <div class="actions-dialog">
                <button mat-stroked-button type="button" class="btn-cancelar" (click)="close()">
                    <mat-icon>close</mat-icon> CANCELAR
                </button>
                <button mat-flat-button class="btn-generar" type="submit" [disabled]="!canSubmit()">
                    <mat-icon>save</mat-icon> GUARDAR
                </button>
            </div>
        </form>
    </div>
</div>
